import React from 'react';
import BlazeInputDropdown, { BlazeDropdownItem } from 'components/ui/dropdown/BlazeDropdown/BlazeInputDropdown';
import { Configuration } from '../../../types/rest/configurationsType';

export const defaultConfiguration: BlazeDropdownItem = {
  id: '-1',
  name: '- No Configuration -',
};

type ConfigurationsDropDownProps = {
  id: any;
  configurationsList: Configuration[];
  /** Current Configuration selected */
  selectedConfigurationId: number | null;
  /** On Change handler */
  onChangeConfiguration: (configurationId: number | null) => void;
  disabled?: boolean;
};

const ConfigurationsDropDown = (props: ConfigurationsDropDownProps) => {
  const selectConfigurationHandler = (item: BlazeDropdownItem) => {
    props.onChangeConfiguration(item.id as number);
  };

  const configurationItems: BlazeDropdownItem[] = props.configurationsList.map(cg => ({ id: cg.id, name: cg.name }));

  /** Converts id of selected configuration to BlazeDropdownItem */
  const getSelectedItem = (): BlazeDropdownItem => {
    if (props.selectedConfigurationId === null) {
      return defaultConfiguration;
    }
    const config: BlazeDropdownItem = configurationItems.find(item => item.id === props.selectedConfigurationId);
    return config ? config : defaultConfiguration;
  };

  return (
    <>
      <div className="d-inline-block" style={{ minWidth: '200px', width: '100%' }}>
        <BlazeInputDropdown
          id={'configuration-picker' + props.id}
          showGroups={false}
          isSearchable={false}
          minDropdownMenuWidth={290}
          maxDropdownHeight={250}
          items={configurationItems}
          selected={getSelectedItem()}
          onClick={selectConfigurationHandler}
          isDefaultOptionSelectable={true}
          defaultOption={defaultConfiguration}
          disabled={props.disabled}
        ></BlazeInputDropdown>
      </div>
    </>
  );
};

export default ConfigurationsDropDown;
